import React, { useState } from 'react';
import {
    InputWithUnit,
    UnitSwitcher,
    UnitOption
} from './UnitInput.styles';

const UnitInput = ({ value, onChange, units = ['px'], defaultUnit = 'px', ...props }) => {
    const [currentUnit, setCurrentUnit] = useState(defaultUnit);
    const [numericValue, setNumericValue] = useState(value || '');

    const handleValueChange = (e) => {
        const newValue = e.target.value;
        setNumericValue(newValue);
        onChange?.({ value: newValue, unit: currentUnit });
    };

    const handleUnitChange = (unit) => {
        setCurrentUnit(unit);
        onChange?.({ value: numericValue, unit });
    };

    return (
        <InputWithUnit>
            <input
                type="text"
                value={numericValue}
                onChange={handleValueChange}
                {...props}
            />
            <UnitSwitcher>
                {units.map(unit => (
                    <UnitOption
                        key={unit}
                        selected={currentUnit === unit}
                        onClick={() => handleUnitChange(unit)}
                    >
                        {unit}
                    </UnitOption>
                ))}
            </UnitSwitcher>
        </InputWithUnit>
    );
};

export default UnitInput; 